<template>
  <div id="calc" :class="infoStatus">
    <div id="map-canvas">
      <gmap-map ref="gmap" @zoom_changed="updateZoom" @dragend="dragend" @center_changed="updateCenter" :resize-bus="customBus" :center="center" :zoom="zoom" :options="mapOptions" disableDefaultUI="false" style="width: 100%; height: 100%; position: absolute; left:0; top:0">
        <g-marker v-for="(firm, index) in firms" :key="firm.id"
          :options="firm" :map="mapObj" @click="toggleGarage(firm)"></g-marker>
        <g-polygon :map="mapObj"></g-polygon>
      </gmap-map>
      <div id="input-wrapper" v-if="geocoder" v-show="infoStatus=='close'">
        <input type="text" v-model="startAddress" placeholder="起點">
        <input type="text" v-model="endAddress" placeholder="終點">
        <button id="start-btn" @click="getAddress('startAddress')"><i class="material-icons">gps_fixed</i></button>
        <button id="end-btn" @click="getAddress('endAddress')"><i class="material-icons">gps_fixed</i></button>
        
      </div>
      <div class="full-btn-wrapper">
        <mt-button v-if="infoStatus=='open'&&!firmMode" class="order" type="primary" @click="toOrder">叫車</mt-button>
        <mt-button v-if="infoStatus=='open'&&!firmMode" class="cancel" type="danger" @click="toggle">重新計算</mt-button>
        <mt-button v-if="infoStatus=='open'&&firmMode" class="order" type="primary" @click="toEndAddress">拖吊到這裡</mt-button>
        <mt-button v-if="infoStatus=='open'&&firmMode" class="cancel" type="danger" @click="toggleGarage(false)">重新選擇</mt-button>
        <mt-button v-if="infoStatus=='close'" class="close" :disabled="isDisabled" type="primary" @click="codeAddress">估算價格</mt-button>
      </div>
    </div>
    <div id="info-wrapper" :class="infoStatus">
      <div v-if="!firmMode">
        <p>路程：{{ distance }} 公里</p>
        <p>價格：{{ price }} 元</p>
        <p v-if="isHoliday">假日/夜間：{{ holiday }} 元</p>
        <p>總價：{{ total }} 元</p>
        <p class="red">{{ msg }}</p>
      </div>
      <div class="firm-wrapper" v-if="firmMode">
        <div class="box-container">
          <div class="square" v-if="load">
            <img :src="cover_img" alt="">
          </div>
          <p class="name">{{ firm.name }}</p>
          <p class="address"><i class="material-icons">location_on</i>{{ firm.address }}</p>
          <p class="time"><i class="material-icons">access_time</i>{{ open_time }}</p>
        </div>
        <div class="call-to">
          <a :href="call_tel">
            <mt-button type="primary"><i class="material-icons">phone</i> {{ firm.tel }}</mt-button>
          </a>
        </div>
        <a target="_blank" href="https://zh-tw.facebook.com/IGcarcare/" class="igcar-banner">
          <span class="ig-logo">
            <img src="../assets/igcar_logo.png" alt="">
          </span>
          <p>車廠資料由愛駒車友App提供</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { MessageBox } from 'mint-ui';
import { Toast } from 'mint-ui';
import Marker from './Marker';
import Polygon from './Polygon';
import greenPolygon from '../greenArea';
import redPolygon from '../redArea';

export default {
  name: 'Calc',
  data () {
    return {
      mapObj: null,
      center: { lat: 25.047523, lng: 121.539878 },
      currentCenter: { lat: 25.047523, lng: 121.539878 },
      zoom: 11,
      currentZoom: 11,
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: false,
        scrollwheel: false,
        gestureHandling: "cooperative",
      },
      geocoder: null,
      directionsService: null,
      directionsDisplay: null,
      startAddress: '',
      endAddress: '',
      customBus: new Vue(),
      infoStatus: 'close',
      distance: 0,
      price: 0,
      holiday: 0,
      total: 0,
      msg: '',
      doing: false,
      page: 0,
      isBusy: false,
      firms: [],
      tmpFirms: [],
      centerHandler: null,
      mapObj: null,
      firmMode: false,
      firm: {},
      load: true,
      toast: null,
    }
  },
  props: ['calc'],
  components: {
    GMarker: Marker,
    GPolygon:Polygon
  },
  watch: {
    cover_img(value) {
      this.load = false;
      setTimeout(() => {
        this.load = true;
      }, 0);
    }
  },
  computed: {
    call_tel() {
      return 'tel:'+ this.firm.tel;
    },
    open_time() {
      let d = new Date();
      let weekday = d.getDay();
      let day;
      if (weekday === 0) {
        day = 7;
      } else {
        day = weekday;
      }
      let open = parseInt(this.firm['opening_from_'+day]);
      let close = parseInt(this.firm['opening_to_'+day]);
      let openStr = ("0" + open).slice(-4);
      let closeStr = ('0' + close).slice(-4);
      if (open < 0 || close < 0) {
        return '今日不營業';
      } else {
        return openStr.slice(0,2) + ':' + openStr.slice(2,4) + ' ~ ' + closeStr.slice(0,2) + ':' + closeStr.slice(2,4) + ' 今日營業時間';
      }
    },
    cover_img() {
      return "https://s3-us-west-2.amazonaws.com/tw.com.igcar/upload/images/"+this.firm.file_name;
    },
    isDisabled() {
      if (this.startAddress.length === 0 || this.endAddress.length === 0 || this.doing) {
        return true;
      } else {
        return false;
      }
    },
    isHoliday() {
      let d = new Date();
      if (d.getHours() >= 17 || d.getHours() < 9 || d.getDay() == 0 || d.getDay() == 6) {
        this.holiday = 500;
        return true;
      } else {
        this.holiday = 0;
        return false;
      }
    }
  },
  methods: {
    isGreen(location) {
      let tmp = [];
      this.$lodash.each(greenPolygon ,(polygon, key) => {
        let bermudaTriangle = new google.maps.Polygon({paths: polygon});
        let ans = google.maps.geometry.poly.containsLocation(location, bermudaTriangle);
        tmp.push(ans);
      });
      if (tmp.indexOf(true) > -1) {
        return true;
      } else {
        return false;
      }
    },
    isRed(location) {
      let tmp = [];
      this.$lodash.each(redPolygon ,(polygon, key) => {
        let bermudaTriangle = new google.maps.Polygon({paths: polygon});
        let ans = google.maps.geometry.poly.containsLocation(location, bermudaTriangle);
        tmp.push(ans);
      });
      if (tmp.indexOf(true) > -1) {
        return true;
      } else {
        return false;
      }
    },
    toEndAddress() {
      this.endAddress = this.firm.address;
      this.toggleGarage(false);
    },
    toggleGarage(firm) {
      if (!!firm) {
        this.firmMode = true;
        this.infoStatus = 'open';
        this.firm = firm;
      } else {
        setTimeout(() => {
          this.firmMode = false;
        }, 300);
        this.infoStatus = 'close';
      }
    },
    toOrder() {
      this.calc.display = true;
      this.calc.startAddress = this.startAddress;
      this.calc.endAddress = this.endAddress;
      this.calc.price = this.price;
      this.calc.total = this.total;
      this.toggle();
      this.$emit('tabChange', '叫車');
      this.$router.push('/');
    },
    toggle() {
      if (this.infoStatus == 'close') {
        this.infoStatus = 'open';
      } else {
        this.infoStatus = 'close';
      }
      setTimeout(()=>{
        this.customBus.$emit('resize');
      }, 500);
    },
    getMapObject() {
      if (!this.geocoder) {
        this.geocoder = new google.maps.Geocoder();
      }
      if (!this.directionsService) {
        this.directionsService = new google.maps.DirectionsService();
      }
      this.insert();
      setTimeout(() => {
        if (!this.directionsDisplay) {
          this.directionsDisplay = new google.maps.DirectionsRenderer();
          let map = this.$refs.gmap.$mapObject;
          this.mapObj = map;
          this.directionsDisplay.setMap(map);
        }
      }, 0);
      this.getFirms();
    },
    insert() {
      const richMarkerScript = document.createElement('SCRIPT');   
      richMarkerScript.setAttribute('src', this.getHost()+'/lib/js-rich-marker.js');
      document.body.appendChild(richMarkerScript);
    },
    getHost() {
      let host = window.location.host;
      if (host.indexOf('localhost') > -1) {
        return 'http://localhost:3000';
      } else {
        return '';
      }
    },
    getFirms() {
      if (!this.isBusy) {
        this.toast = Toast('取得車廠資料');
        this.isBusy = true;
        this.page = 0;
        this.tmpFirms = [];
        axios.get(`${this.getHost()}/igcar/firms?area_id=0&city_id=-1&distance=${this.getDistance()}&lat=${this.center.lat}&lng=${this.center.lng}&offset=0&order=smart&services=2`)
          .then((res) => {
            res.data.body.firms.forEach((obj) => {
              this.tmpFirms.push(obj);
            });
            if (res.data.body.count < res.data.body.limit || this.tmpFirms.length >= 60) {
              this.firms.length = [];
              this.$lodash(this.tmpFirms);
              this.tmpFirms.forEach((firm) => {
                this.firms.push(firm);
              });
              this.isBusy = false;
              this.toast.close();
            } else {
              this.page = this.page + 1;
              this.nextFirms(20*this.page);
            }
          });
      }
    },
    nextFirms(offset) {
      axios.get(`${this.getHost()}/igcar/firms?area_id=0&city_id=-1&distance=${this.getDistance()}&lat=${this.center.lat}&lng=${this.center.lng}&offset=${offset}&order=smart&services=2`)
        .then((res) => {
          res.data.body.firms.forEach((obj) => {
            this.tmpFirms.push(obj);
          });
          if (res.data.body.count < res.data.body.limit || this.tmpFirms.length >= 60) {
            this.firms.length = [];
            this.$lodash(this.tmpFirms);
            this.tmpFirms.forEach((firm) => {
              this.firms.push(firm);
            });
            this.isBusy = false;
            this.toast.close();
          } else {
            this.page = this.page + 1;
            this.nextFirms(20*this.page);
          }
        })
    },
    updateCenter(newCenter) {
      this.currentCenter = {
        lat: newCenter.lat(), lng: newCenter.lng()
      }
    },
    dragend() {
      this.center = {
        lat: this.currentCenter.lat, lng: this.currentCenter.lng
      }
      this.getFirms();
    },
    updateZoom(zoom) {
      this.currentZoom = zoom;
    },
    getDistance() {
      let zoom = this.currentZoom;
      if (zoom > 13) {
        return 5000;
      } else if (zoom > 11) {
        return 8000;
      } else if (zoom > 10) {
        return 20000;
      } else {
        return 200000;
      }
    },
    getAddress(value) {
      Toast('正在取得位置');
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.getFirms();
        let latlng = new google.maps.LatLng(this.center.lat, this.center.lng);
        this.geocoder.geocode({'latLng': latlng}, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              this[value] = results[0].formatted_address;
            }
          }
        })
      });
    },
    codeAddress() {
      this.doing = true;
      setTimeout(() => {
        this.doing = false;
      }, 1000);
      this.geocoder.geocode({ 'address': this.startAddress }, (results, status) => {
        var result = [];
        if (status == google.maps.GeocoderStatus.OK) {
          results.forEach(function(value) {
            value.address_components.forEach(function(val) {
              if (val.short_name == 'TW') {
                result.push(value);
              }
            })
          });
          if (result.length==0) {
            MessageBox('提示', '查無起點地址');
          } else {
            this.startAddress = result[0].formatted_address;
            this.codeEndAddress();
          }
        }
      });
    },
    codeEndAddress() {
      this.geocoder.geocode({ 'address': this.endAddress }, (results, status) => {
        var result = [];
        if (status == google.maps.GeocoderStatus.OK) {
          results.forEach(function(value) {
            value.address_components.forEach(function(val) {
              if (val.short_name == 'TW') {
                result.push(value);
              }
            })
          });
          if (result.length==0) {
            MessageBox('提示', '查無終點地址');
          } else {
            this.endAddress = result[0].formatted_address;
            this.direction();
          }
        }
      });
    },
    direction() {
      let request = {
        origin: this.startAddress,
        destination: this.endAddress,
        travelMode: google.maps.TravelMode.DRIVING,
        avoidHighways: false
      }
      this.directionsService.route(request, (result, status) => {          
        if (status == google.maps.DirectionsStatus.OK) {
          this.toggle();
          this.directionsDisplay.setDirections(result);
          this.logic(result);
        } else {
          MessageBox('提示', '未知的錯誤');
        }
      });
    },
    logic(result) {
      this.msg = '';
      let data = result.routes[0].legs[0];
      this.distance = Math.ceil((data.distance.value)/1000);
      if(data.distance.value <= 10000) {
        if (this.isGreen(data.start_location) && this.isGreen(data.end_location)) {
          this.price = 1200;
        } else {
          this.price = 2500;
          if (this.isRed(data.start_location) || this.isRed(data.end_location)) {
            this.msg = "您位於極偏遠區，價格議價";
          } else {
            this.msg = "您位於郊區，基本價格2500元"
          }
        }
        this.total = this.price + this.holiday;
      } else if (data.distance.value > 10000) {
        let moreDistance = Math.ceil((data.distance.value - 10000)/1000);
        if (this.isGreen(data.start_location) && this.isGreen(data.end_location)) {
          this.price = (1200 + 50 * moreDistance);
        } else {
          this.price = (2500 + 50 * moreDistance);
          if (this.isRed(data.start_location) || this.isRed(data.end_location)) {
            this.msg = "您位於極偏遠區，價格議價";
          } else {
            this.msg = "您位於郊區，基本價格2500元"
          }
        }
        this.total = this.price + this.holiday;
      }
    }
  },
  created() {
    let interval = setInterval(() => {
      if (google) {
        this.getMapObject();
        clearInterval(interval);
      }
    }, 100);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #calc {
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 51px;
    transition: padding-bottom 0.3s;
    overflow: hidden;
  }
  #calc.open {
    padding-bottom: 200px;
    transition: padding-bottom 0.3s;
  }
  #info-wrapper {
    position: absolute;
    width: 100%;
    height: 200px;
    bottom: 0;
    left: 0;
    overflow: hidden;
  }
  #info-wrapper.open {
    margin-bottom: 0;
    transition: margin-bottom 0.3s;
    -webkit-box-shadow: 0px -2px 5px 0px rgba(0,0,0,0.24);
    -moz-box-shadow: 0px -2px 5px 0px rgba(0,0,0,0.24);
    box-shadow: 0px -2px 5px 0px rgba(0,0,0,0.24);
  }
  #info-wrapper.close {
    margin-bottom: -200px;
    transition: margin-bottom 0.3s;
  }
  #info-wrapper .firm-wrapper {
    position: relative;
    text-align: left;
    height: 100%;
  }
  #info-wrapper .box-container {
    box-sizing: border-box;
    padding: 6px 6px 0 102px;
    position: relative;
  }

  #info-wrapper .box-container p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space : nowrap;
    line-height: 30px;
  }
  #info-wrapper .box-container p i {
    vertical-align: middle;
    margin-right: 5px;
  }
  #info-wrapper .box-container p.name {
    font-size: 18px;
  }
  #info-wrapper .square {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 90px;
    height: 90px;
    box-sizing: border-box;
    background: #f1f1f1;
    border: 1px solid rgba(0,0,0,0.2);
  }
  #info-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  #map-canvas {
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    position: relative;
    box-sizing: border-box;
  }
  #input-wrapper {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    box-sizing: border-box;
    padding: 6px;
  }
  #input-wrapper input {
    display: block;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 3px;
    padding: 10px 50px 10px 10px;
    border: 1px solid rgba(0,0,0,0.2);
    opacity: 0.9;
  }
  #input-wrapper input:focus {
    opacity: 1;
  }
  #start-btn, #end-btn {
    border: 0;
    background: transparent;
    height: 37px;
    width: 50px;
    position: absolute;
    box-sizing: border-box;
    padding: 0;
  }
  #start-btn i, #end-btn i {
    line-height: 37px;
  }
  #start-btn {
    color: green;
    top: 6px;
    right: 6px;
  }
  #end-btn {
    color: red;
    top: 46px;
    right: 6px;
  }
  .full-btn-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 6px;
    width: 100%;
    box-sizing: border-box;
    opacity: 0.9;
  }
  .full-btn-wrapper button {
    width: 100%;
  }
  .full-btn-wrapper .order {
    margin-bottom: 6px;
  }
  .call-to {
    padding: 6px;
    width: 100%;
    box-sizing: border-box;
    vertical-align: middle
  }
  .call-to i {
    vertical-align: middle
  }
  .call-to button {
    width: 100%;
  }
  a.igcar-banner {
    display: block;
    width: 100%;
    position: absolute;
    height: 50px;
    bottom: 0;
    left: 0;
    background: #cb0015;
    padding: 5px 12px;
    box-sizing: border-box;
    color: #fff;
    text-decoration: none;
  }
  a.igcar-banner p {
    margin: 0;
    padding-left: 50px;
    line-height: 40px;
    text-align: center;
  }
  a.igcar-banner .ig-logo {
    position: absolute;
    top: 5px;
    left: 12px;
    display: inline-block;
    width: 40px;
    height: 40px;

  }
  .ig-logo img {
    width: 100%;
    height: 100%;
  }
  p.red {
    color: #f00;
  }


</style>



// WEBPACK FOOTER //
// src/components/Calc.vue